import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';



class FooterPage extends Component {
    render() {
        return (
            <div className="page-footer font-small pt-2">

                <Container className="mt-3 mb-2">


                    <Row className="border-top-footer">
                        <Col className="text-left-footer dark-grey-text p-4">
                            &copy; {(new Date().getFullYear())} Copyright: <a href="https://www.iranroute.com" className="dark-grey-text">  iranroute</a>
                       </Col>
                    </Row>
                </Container>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(FooterPage);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js